import useScrollAnimation from '../hooks/useScrollAnimation'; // 경로가 맞는지 확인

const AnimatedSection = ({ children, className = "", animationType = "fade-in-up", id = "", style = {} }) => {
  const [ref, isVisible] = useScrollAnimation(0.2); // 20% 보일 때 애니메이션 시작

  const animationClasses = {
    "fade-in": `transition-opacity duration-1000 ease-out ${isVisible ? 'opacity-100' : 'opacity-0'}`,
    "fade-in-up": `transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`,
    "fade-in-left": `transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`,
    "fade-in-right": `transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`,
    "scale-up": `transition-transform duration-700 ease-out ${isVisible ? 'scale-100 opacity-100' : 'scale-90 opacity-0'}`
  };
  
  return (
    <div ref={ref} id={id} className={`${className} ${animationClasses[animationType] || animationClasses["fade-in-up"]}`} style={style}>
      {children}
    </div>
  );
};

export default AnimatedSection;
